// LessonVideoUpload: upload a lesson video, watch it upload and get prepared, retry on failure.
const lessonVideo = {
  en: {
    title: 'Lesson video',
    dropTitle: 'Drop the video here',
    dropActive: 'Release to upload',
    or: 'or',
    choose: 'Choose a file',
    hint: 'MP4, MOV, WEBM or MKV, up to {max}',
    hasVideo: 'This lesson already has a video. A new upload replaces it once it is ready.',
    uploading: 'Uploading {percent}%',
    uploadedOf: '{done} of {total}',
    cancel: 'Cancel',
    processing: 'Preparing',
    processingPercent: 'Preparing {percent}%',
    processingHint: 'The video is being converted for every screen and connection. This takes a few minutes and carries on if you close this page.',
    ready: 'Ready',
    readyHint: 'The video is on the lesson.',
    replace: 'Upload another video',
    error: 'Error',
    retry: 'Try again',
    chooseAnother: 'Choose another file',
    previousKept: 'The lesson keeps its previous video.',
    leaveWarning: 'The video is still uploading. Leaving this page stops the upload.',
    progressLabel: 'Video upload progress',
    errors: {
      notVideo: 'This file is not a video, or it is damaged.',
      unsupportedType: 'This kind of file cannot be uploaded. Choose an MP4, MOV, WEBM or MKV video.',
      tooLarge: 'The file is too large. It must be at most {max}.',
      oneFile: 'Choose one file.',
      uploadFailed: 'The file did not upload. Check the internet connection and try again.',
      linkExpired: 'The upload link expired. Try again.',
      sourceMissing: 'The uploaded file was not found. Upload it again.',
      transcodeFailed: 'The video could not be prepared. Try another file.',
      stalled: 'Preparing the video stopped. Try again.',
      unavailable: 'Video upload is not working right now. Try again in a few minutes.',
      forbidden: 'You cannot upload a video to this lesson.',
      generic: 'Something went wrong. Try again.',
    },
  },
  ru: {
    title: 'Видео урока',
    dropTitle: 'Перетащите видео сюда',
    dropActive: 'Отпустите, чтобы загрузить',
    or: 'или',
    choose: 'Выбрать файл',
    hint: 'MP4, MOV, WEBM или MKV, до {max}',
    hasVideo: 'В уроке уже есть видео. Новое заменит его, когда будет готово.',
    uploading: 'Загрузка {percent}%',
    uploadedOf: '{done} из {total}',
    cancel: 'Отменить',
    processing: 'Обработка',
    processingPercent: 'Обработка {percent}%',
    processingHint: 'Видео готовится для всех экранов и скоростей интернета. Это займёт несколько минут и продолжится, даже если закрыть страницу.',
    ready: 'Готово',
    readyHint: 'Видео добавлено в урок.',
    replace: 'Загрузить другое видео',
    error: 'Ошибка',
    retry: 'Повторить',
    chooseAnother: 'Выбрать другой файл',
    previousKept: 'В уроке осталось прежнее видео.',
    leaveWarning: 'Видео ещё загружается. Если уйти со страницы, загрузка остановится.',
    progressLabel: 'Ход загрузки видео',
    errors: {
      notVideo: 'Этот файл не видео или он повреждён.',
      unsupportedType: 'Такой файл загрузить нельзя. Выберите видео MP4, MOV, WEBM или MKV.',
      tooLarge: 'Файл слишком большой. Допустимо не больше {max}.',
      oneFile: 'Выберите один файл.',
      uploadFailed: 'Файл не загрузился. Проверьте интернет и попробуйте ещё раз.',
      linkExpired: 'Ссылка для загрузки устарела. Попробуйте ещё раз.',
      sourceMissing: 'Загруженный файл не найден. Загрузите его заново.',
      transcodeFailed: 'Не удалось подготовить видео. Попробуйте другой файл.',
      stalled: 'Обработка видео остановилась. Попробуйте ещё раз.',
      unavailable: 'Загрузка видео сейчас не работает. Попробуйте через несколько минут.',
      forbidden: 'Вы не можете загружать видео в этот урок.',
      generic: 'Что-то пошло не так. Попробуйте ещё раз.',
    },
  },
  uz: {
    title: 'Dars videosi',
    dropTitle: 'Videoni shu yerga tashlang',
    dropActive: 'Yuklash uchun qo\'yib yuboring',
    or: 'yoki',
    choose: 'Fayl tanlash',
    hint: 'MP4, MOV, WEBM yoki MKV, {max} gacha',
    hasVideo: 'Bu darsda video bor. Yangi video tayyor bo\'lgach, uning o\'rnini egallaydi.',
    uploading: 'Yuklanmoqda {percent}%',
    uploadedOf: '{done} / {total}',
    cancel: 'Bekor qilish',
    processing: 'Tayyorlanmoqda',
    processingPercent: 'Tayyorlanmoqda {percent}%',
    processingHint: 'Video har xil ekran va internet tezligi uchun tayyorlanmoqda. Bu bir necha daqiqa oladi va sahifani yopsangiz ham davom etadi.',
    ready: 'Tayyor',
    readyHint: 'Video darsga qo\'shildi.',
    replace: 'Boshqa video yuklash',
    error: 'Xatolik',
    retry: 'Qayta urinish',
    chooseAnother: 'Boshqa fayl tanlash',
    previousKept: 'Darsdagi oldingi video o\'zgarmadi.',
    leaveWarning: 'Video hali yuklanmoqda. Sahifadan chiqsangiz, yuklash to\'xtaydi.',
    progressLabel: 'Video yuklanishi',
    errors: {
      notVideo: 'Bu fayl video emas yoki buzilgan.',
      unsupportedType: 'Bunday faylni yuklab bo\'lmaydi. MP4, MOV, WEBM yoki MKV video tanlang.',
      tooLarge: 'Fayl juda katta. U {max} dan oshmasligi kerak.',
      oneFile: 'Bitta fayl tanlang.',
      uploadFailed: 'Fayl yuklanmadi. Internetni tekshirib, qayta urinib ko\'ring.',
      linkExpired: 'Yuklash havolasining muddati tugadi. Qayta urinib ko\'ring.',
      sourceMissing: 'Yuklangan fayl topilmadi. Uni qaytadan yuklang.',
      transcodeFailed: 'Videoni tayyorlab bo\'lmadi. Boshqa fayl bilan urinib ko\'ring.',
      stalled: 'Videoni tayyorlash to\'xtab qoldi. Qayta urinib ko\'ring.',
      unavailable: 'Video yuklash hozir ishlamayapti. Bir necha daqiqadan so\'ng urinib ko\'ring.',
      forbidden: 'Bu darsga video yuklay olmaysiz.',
      generic: 'Nimadir xato ketdi. Qayta urinib ko\'ring.',
    },
  },
};

export default lessonVideo;
